import classnames from "classnames";
import React, {Component} from "react";
import PropTypes from "prop-types";
import {IndexLink, Link} from "react-router";

import {AuthUser} from "v2/api/Records";

export default class Header extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }
  static defaultProps = {
    user: null,
  }
  static propTypes = {
    onLogout: PropTypes.func,
    user: PropTypes.instanceOf(AuthUser),
  }

  renderBars() {
    return (
      <button
        className="navbar-toggle collapsed"
        data-target="#erg-navbar-collapse"
        data-toggle="collapse"
        type="button">
        <span className="sr-only">Toggle Navigation</span>
        <span className="icon-bar" />
        <span className="icon-bar" />
        <span className="icon-bar" />
      </button>
    );
  }

  renderLogo() {
    return (
      <IndexLink activeClassName="active" className="navbar-brand" to="/">
        <img
          alt="Coordinator App"
          height={25}
          src={require("../../../assets/coordinator-logo.svg")} />
      </IndexLink>
    );
  }

  renderMenu() {
    const routesClassName = classnames({
      active: true,
    });

    return (
      <ul className="nav navbar-nav navbar-links">
        <li className={routesClassName}><Link to="/">Routes</Link></li>
      </ul>
    );
  }

  renderUser() {
    const {onLogout, user} = this.props;
    return (
      <ul className="nav navbar-nav navbar-right">
        <li className="dropdown">
          <a
            aria-expanded={false}
            className="dropdown-toggle"
            data-toggle="dropdown"
            href="#"
            role="button">
            <span className="fa fa-user" /> {user.fullName || user.email} <span className="caret" />
          </a>
          <ul className="dropdown-menu" role="menu">
            <li><a href="#" onClick={onLogout}>Logout</a></li>
          </ul>
        </li>
      </ul>
    );
  }

  render() {
    const {user} = this.props;

    let userNode;
    if (user) {
      userNode = (
        <div className="collapse navbar-collapse" id="erg-navbar-collapse">
          {this.renderMenu()}
          {this.renderUser()}
        </div>
      );
    }

    return (
      <nav className="navbar navbar-default erg-navbar">
        <div className="container-fluid">
          <div className="navbar-header">
            {this.renderBars()}
            {this.renderLogo()}
          </div>
          {userNode}
        </div>
      </nav>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/Header.js
 **/